import { NumberMembershipFieldKey } from '../../const/discipline-memberships-const'
import { IPaymentStatus, IPaymentType } from '../../types/payment'
import { ISignedStatuses } from '../../store/events/types'
import { IUserCoreInterface } from '../users-core/users-core.interface'

export const MEMBERSHIP_TYPE = {
  ANNUAL: 'Annual',
  MONTHLY: 'Monthly',
  BOARD: 'Board',
  PAYMENT: 'Payment',
  FREE: 'Free',
}

export type IMembershipInterval = 'day' | 'week' | 'month' | 'year' | null
export type IMembershipType = 'Annual' | 'Monthly' | 'Board' | 'Payment' | 'Free' | null

export interface IMembershipsInterface {
  id: string
  name: string | null
  description: string | null
  price: number
  cancellationPeriod: number | null
  pricingDescription: string | null
  type: IMembershipType
  userStripeAccountId: string | null
  stripeProductId?: string | null
  stripePriceId?: string | null
  interval: IMembershipInterval
  amount: number
  termsAndConditions: string | null
}

export type IUserLocationInterface = {
  lat: number | null
  lng: number | null
}

export interface IRiderTeamMember {
  selected?: ITeamMember['selected']
  memberDob?: ITeamMember['memberDob']
  memberId: IUserTeamMember['memberId']
  memberName?: ITeamMember['memberName']
  memberRole?: ITeamMember['memberRole']
  defaultRole?: ITeamMember['defaultRole']
  memberEmail?: ITeamMember['memberEmail']
  signedStatus?: ITeamMember['signedStatus']
  memberProfilePicture?: ITeamMember['memberProfilePicture']
  connectedDate?: ITeamMember['connectedDate']
}

export type ISelect = {
  label?: any
  value?: string
  light_icon?: string
  dark_icon?: string
  ccode?: string
}

export interface IUserTeamMember {
  teamMateRole: string
  teamMatePic?: string
  teamMateEmail: string
  memberId: string | null
  teamMateAddress: string
  teamMateUsername: string
  teamMateStatus?: boolean
  teamMateprofileSynced?: boolean
  teamMateMemberShipActive?: boolean
  teamMateMemberSafeSupportTraining?: boolean
}

export type INotificationSettings = {
  newMessages: boolean
  weatherUpdates: boolean
  resultUpdates: boolean
  courseUpdates: boolean
  paymentUpdates: boolean
} | null

export type ITeamMember = {
  userHorseMappingId?: string | null
  id?: string | null
  userId?: string | null
  selected?: boolean
  memberEmail: string | null
  horseId?: string | null
  defaultRole?: string
  isScratched?: boolean
  refundAmount?: number
  memberCountry: string | null
  connectedDate?: Date | string | null
  memberAddress?: string
  recipient?: IRecipient
  memberId: string | null
  memberRole?: string | null
  memberName: string | null
  memberUserName?: string | null
  signedStatus?: ISignedStatuses
  memberDob: string | Date | null
  memberPhoneNumber?: string | null
  horses?: IRegisterTabsSelectData[]
  memberProfilePicture: string | null
  HorseTeamMembers?: any[]
  HorseTeamIdLIst?: string[]
  riderTeamMembers?: IRiderTeamMember[]
}

export type IRegisterTabsSelectData = {
  id: string
  name?: string
  label?: string
  value?: string
  horseProfilePicture?: string
}

export interface IRecipient {
  invoiceId?: string
  invoiceUrl?: string
  recipientName?: string
  recipientEmail?: string
  recipientId: string | null
  recipientAmountToPay: number
  recipientDefaultRole?: string
  recipientPaymentStatus?: IPaymentStatus
}

export interface IRecipientTotalItem {
  amount: number
  memberId: string
  memberName?: string
}

export interface IUserCard {
  cardNumber: string | null
  cardType: string | null
  pmId: string | null
  customerId: string | null
  expiryMonth: number | null
  expiryYear: number | null
  default: boolean
  type: 'card'
}

export interface IUserACH {
  cardNumber: string | null
  bankName: string | null
  pmId: string | null
  customerId: string | null
  routingNumber: string | null
  default: boolean
  type: 'us_bank_account'
}

export type IPaymentsCards = {
  CARDS: IUserCard[]
  ACH: IUserACH[]
}

export interface ISelectedCard {
  type: IPaymentType
  pmId: string | null
  cardNumber: string | null
}

export type IUserDocuments = {
  status?: string
  membershipStatus: string
  startDate: Date | null
  endDate: Date | string | null
  validTill: Date | null
  documentFullName: string
  documentNumber: string
  image: string
}

export type TUserPocDetails = {
  pocFirstName: string
  pocLastName: string
  pocFullName: string
  pocPhone: string
  pocEmail: string
}

export type TUserDocumentAndExpiration = {
  file: string
  validTill: Date | string
}

export type NumberMembershipItem = {
  fieldKey: NumberMembershipFieldKey
  label: string
  icon?: string
}

export type NumberMembershipGroupKey =
  | 'English'
  | 'Western'
  | 'Rodeo'
  | 'College'
  | 'Other'
  | 'Pegasus'

export interface IUserInterface extends IUserCoreInterface {
  userOrganizationName?: string
  userPhoneNumber?: string
  userPhoneCode?: string
  userDefaultRole?: string
  vendorname?: string | null

  userBusinessName?: string | null
  userAlternativeNumber?: string
  userSocialSecurityNumber?: string

  userConnectAccountStatusMessage?: string | null
  userBankConnected?: boolean
  userStripeAccountId?: string | null
  userStripeAccountStatus?: 'pending' | 'connected' | null
  userStripeId?: string
  // stripe default payment method id
  userStripeDefaultPmId?: string | null

  userSafeSupportExpiry?: Date | null
  userSafeSupportStatus?: string | null

  userBackgroundCheckExpiry?: Date | null
  userBackgroundCheckStatus?: string | null

  userNotificationsSettings?: INotificationSettings | null

  userBrandImages?: string[]
  userBrandVideos?: string[]

  userJudgingLicense?: string | ISelect

  userForeignEndorsement?: TUserDocumentAndExpiration

  userLegalPolicyName?: string
}

export interface IUserInterfaceExtended extends IUserInterface {
  userHorses?: any[]
  HorseTeamMembers?: any[]
  HorseTeamIdLIst?: string[]
}
